import type { InvoiceDto } from "../api/invoices-api";
import { paymentModeLabel } from "./document-mappers";

const STATUS_LABEL: Record<string, string> = {
  DRAFT: "Draft",
  ISSUED: "Unpaid",
  PAID: "Paid",
  PARTIAL: "Partially Paid",
  OVERDUE: "Overdue",
  CANCELLED: "Cancelled",
  REFUNDED: "Refunded",
};

export function formatMoney(amount: string, currency: string) {
  const n = Number.parseFloat(amount);
  if (Number.isNaN(n)) return amount;
  return new Intl.NumberFormat("en-US", { style: "currency", currency }).format(n);
}

export function invoiceToTableRow(inv: InvoiceDto, index: number) {
  const meta =
    inv.metadata && typeof inv.metadata === "object" && !Array.isArray(inv.metadata)
      ? (inv.metadata as Record<string, unknown>)
      : {};
  const paymentFromMeta = meta.lastPaymentMode ? String(meta.lastPaymentMode) : null;
  const paymentFromField = "paymentMode" in inv ? (inv as InvoiceDto & { paymentMode?: string }).paymentMode : null;
  return {
    key: inv.id,
    rowId: inv.id,
    customerId: inv.customer.id,
    Image: `avatar-${(index % 28) + 1}.jpg`,
    ID: inv.number,
    Customer: inv.customer.displayName,
    Created_On: new Date(inv.createdAt).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }),
    Amount: formatMoney(inv.total, inv.currency),
    Paid: formatMoney(inv.paidAmount, inv.currency),
    Status: STATUS_LABEL[inv.status] ?? inv.status,
    Payment_Mode: paymentModeLabel(paymentFromField ?? paymentFromMeta),
    Due_Date: inv.dueDate
      ? new Date(inv.dueDate).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
      : "—",
  };
}

export function statusBadgeClass(status: string) {
  const map: Record<string, string> = {
    PAID: "badge-soft-success",
    REFUNDED: "badge-soft-success",
    ISSUED: "badge-soft-info",
    PARTIAL: "badge-soft-warning",
    OVERDUE: "badge-soft-danger",
    CANCELLED: "badge-soft-danger",
    DRAFT: "badge-soft-secondary",
  };
  return map[status] ?? "badge-soft-info";
}
